import { useQuery } from '@tanstack/react-query'
import {
  getUpcomingInvoiceDetail,
  GetUpcomingInvoiceDetailParams,
} from 'api/payment'
import { QueryOptions } from 'queries/types'
import { upcomingInvoiceDetailKey } from './keys'

type UseUpcomingInvoiceDetail = {
  companyId?: number
  periodStart?: string
  invoiceGroupKey: string[]
}

export function useUpcomingInvoiceDetail(
  options: UseUpcomingInvoiceDetail,
  queryOptions: QueryOptions<typeof getUpcomingInvoiceDetail> = {}
) {
  const { companyId, periodStart, invoiceGroupKey } = options
  const params: GetUpcomingInvoiceDetailParams | undefined =
    periodStart !== undefined ? { periodStart, invoiceGroupKey } : undefined

  return useQuery({
    ...queryOptions,
    queryKey: upcomingInvoiceDetailKey(companyId, periodStart, invoiceGroupKey),
    queryFn: ({ signal }) => {
      if (companyId === undefined || params === undefined) {
        throw new Error('Company and periodStart are required')
      }
      return getUpcomingInvoiceDetail(companyId, params, signal)
    },
    enabled:
      companyId !== undefined &&
      periodStart !== undefined &&
      (queryOptions.enabled ?? true),
  })
}
